export default function translate(key, lang = window.currentLang) {
    const fallbackLang = "cs";
    const props = key.split(".");
    let translation = window.translations[lang];

    try {
        for (const prop of props) {
            translation = translation[prop];
        }
    } catch (error) {
        return key;
    }

    if (!translation) return key;

    return translation;
}
